import { Button } from "../../common/button/button";
import { PopupWindow } from "../popup-window/popup-window";
import styles from "./confirmation-popup.module.scss";
import ReactMarkdown from "react-markdown";
import { Fragment, useContext } from "react";
import { StylesContext } from "../../../contexts/styles-context/styles.context";

interface ConfirmationPopupProps {
  active: boolean;
  header: string;
  buttonText: string;
  onButtonClick?: () => void;
  onClose?: () => void;
}

export function ConfirmationPopup(props: React.PropsWithChildren<ConfirmationPopupProps>) {
  const { header, buttonText, onButtonClick, onClose, children, active } = props;
  const { styles: { allButtons = {}, primaryButtons = {} } } = useContext(StylesContext);

  const clickHandler = () => {
    onButtonClick && onButtonClick();
    onClose && onClose();
  }

  return (
    <PopupWindow active={active} onClose={onClose}>
      <div className={styles.container}>
        <h2 className={styles.header}>
          <ReactMarkdown
            source={header}
            escapeHtml={false}
            renderers={{ paragraph: props => <Fragment children={props.children} /> }}
          />
        </h2>
        {children}
        <Button customStyles={{ ...allButtons, ...primaryButtons}} value={buttonText} mode="confirm" onClick={clickHandler}/>
      </div>
    </PopupWindow>
  )
}